import { useEffect } from 'react';
import { tw } from 'twind';
import { Icon } from '@global-ecom/nitro-uds/elements';

import { useCart } from 'hooks/useCart';
import { GooglePayButtonType, useGooglePay } from 'hooks/useGooglePay';
import { useSiteConfig } from 'hooks/useSiteConfig';
import { Button } from 'ui/elements/Button';
import { AnalyticsEvents, event, paymentClickEvent } from 'utils/analytics';

export const GooglePayButton = ({
  buttonType,
  disabled,
}: {
  buttonType: GooglePayButtonType;
  disabled?: boolean;
}) => {
  const { language } = useSiteConfig();
  const {
    enableGooglePay,
    isGooglePayEnabled,
    injectButtonStyles,
    handleGooglePay,
  } = useGooglePay();
  const { cart, cartResult } = useCart({ pause: !isGooglePayEnabled });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(enableGooglePay, []);

  useEffect(() => {
    if (isGooglePayEnabled) injectButtonStyles(buttonType);
  }, [isGooglePayEnabled, buttonType]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isGooglePayEnabled) return null;

  return (
    <Button
      arial-label="Google Pay"
      className={tw(
        'bg-white border-puma-black-700 !w-full !h-14 hover:(bg-neutral-20 border-neutral-20)',
        buttonType,
        buttonType === 'pay' && language
      )}
      dataTestId="google-pay-button"
      disabled={disabled || !cart || cartResult.stale}
      onClick={() => {
        handleGooglePay();
        event(AnalyticsEvents.PAYMENT_TYPE_SELECTED, {
          ecommerce: {
            name: AnalyticsEvents.PAYMENT_TYPE_SELECTED,
            value: 'Google Pay',
          },
        });
        paymentClickEvent();
      }}
      type="button"
    >
      <Icon name="payment-google-pay" size="9xl" />
    </Button>
  );
};
